import React from "react";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import { LeaveAndUpcomingHistoryListType } from "../../../../redux/stcoTools/stcoToolsType";
import { formatDate } from "../../../../utils/commonFunctions";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { CircularAvatar } from "../../../commons";
import { useLocation, useParams } from "react-router-dom";
import { ViewIcon } from "../../../../assets/images";
type AppProps = {
  tableHeader: TableHeadersType[];
  data: [] | LeaveAndUpcomingHistoryListType[];
  // handleRequestAppoved?: (data: string) => void;
  // handleRequestReject?: (data: string) => void;
  history: any;
};
const LeavePendingApprovalTableData = ({
  tableHeader,
  data,
  // handleRequestAppoved,
  // handleRequestReject,
  history,
}: AppProps) => {
  const idParames: any = useParams();
  const id =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.id
      ? history.location.state.id
      : idParames?.id
      ? idParames?.id
      : "";
  return (
    <>
      {data?.length > 0 &&
        data?.map((el: any) => {
          return (
            <tr className="text-left">
              {tableHeader?.length > 0 &&
                tableHeader?.map((header: TableHeadersType) => {
                  let createdName = `${
                    el?.created_by?.first_name ? el?.created_by?.first_name : ""
                  }   ${
                    el?.created_by?.first_name ? el?.created_by?.last_name : ""
                  }`;
                  if (header?.value === "applied_on") {
                    return (
                      <td
                        className="text-left mt-5"
                        style={{ minWidth: "120px" }}
                      >
                        {formatDate(el?.created_at)}
                      </td>
                    );
                  } else if (header?.value === "leave_from") {
                    return (
                      <td
                        className="text-left mt-5"
                        style={{ minWidth: "120px" }}
                      >
                        {el?.start_date ? el?.start_date : "NA"}
                      </td>
                    );
                  } else if (header?.value === "leave_to") {
                    return (
                      <td
                        className="text-left mt-5"
                        style={{ minWidth: "120px" }}
                      >
                        {el?.end_date ? el?.end_date : "NA"}
                      </td>
                    );
                  } else if (header?.value === "no_of_days") {
                    return (
                      <td
                        className="text-left mt-5"
                        // style={{ minWidth: "180px" }}
                      >
                        {el?.total_days > 9
                          ? el?.total_days
                          : `${el?.total_days}`}{" "}
                        days
                      </td>
                    );
                  } else if (header?.value === "leave_type") {
                    return (
                      <td
                        className="text-left mt-5 "
                        style={{ minWidth: "150px" }}
                      >
                        <div
                          className="d-flex align-items-center"
                          style={{ gap: "10px", whiteSpace: "nowrap" }}
                        >
                          <div>
                            <span
                              className={
                                el?.leave_type === "Unpaid Leave"
                                  ? "status-incomplete"
                                  : el?.leave_type === "Full time(Unpaid Leave)"
                                  ? "status-Pending"
                                  : "estimatePurchase"
                              }
                              style={{
                                fontWeight: 500,
                                borderRadius: "16px",
                                padding: "5px 10px",
                              }}
                            >
                              {el?.leave_type === "Unpaid Leave"
                                ? "Unpaid Leave"
                                : el?.leave_type === "Casual Leave"
                                ? "Casual Leave"
                                : el?.leave_type ===
                                  "Casual leave(Unpaid Leave)"
                                ? "Casual Leave"
                                : "Unpaid Leave"}
                            </span>
                          </div>
                          {el?.leave_type === "Casual leave(Unpaid Leave)" && (
                            <div
                              className={"status-Pending"}
                              style={{
                                fontWeight: 500,
                                borderRadius: "16px",
                                padding: "5px 10px",
                              }}
                            >
                              Unpaid Leave
                            </div>
                          )}
                        </div>
                      </td>
                    );
                  }

                  if (header?.value == "leave_applied_by") {
                    return (
                      <td className="text-left" style={{ minWidth: "200px" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div className="mr-2">
                            <CircularAvatar
                              name={el?.created_by?.createdName}
                              image={
                                el?.created_by?.profile_pic &&
                                el?.created_by.profile_pic?.file_url
                              }
                            />
                          </div>
                          <div>
                            {createdName?.length > 70 ? (
                              <OverlayTrigger
                                placement="bottom"
                                delay={{ show: 250, hide: 250 }}
                                overlay={
                                  <Tooltip id="button-view-open-item">
                                    {createdName}
                                  </Tooltip>
                                }
                              >
                                <div>
                                  {createdName
                                    ? createdName?.substr(0, 70) +
                                      (createdName && createdName?.length > 70
                                        ? "..."
                                        : "")
                                    : "NA"}
                                </div>
                              </OverlayTrigger>
                            ) : (
                              <>{createdName ? createdName : "NA"}</>
                            )}
                          </div>
                        </div>
                      </td>
                    );
                  } else if (header?.value === "reason") {
                    return (
                      <td
                        className="text-left mt-5"
                        style={{ minWidth: "200px" }}
                      >
                        {el?.reason?.length > 150 ? (
                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 250 }}
                            overlay={
                              <Tooltip id="button-view-open-item">
                                {el?.reason}
                              </Tooltip>
                            }
                          >
                            <div>
                              {el?.reason
                                ? el?.reason?.substr(0, 150) +
                                  (el?.reason && el?.reason?.length > 150
                                    ? "..."
                                    : "")
                                : "NA"}
                            </div>
                          </OverlayTrigger>
                        ) : (
                          <>{el?.reason ? el?.reason : "NA"}</>
                        )}
                      </td>
                    );
                  } else if (header?.value === "status") {
                    return (
                      <td
                        className={`text-left mt-5`}
                        style={{ minWidth: "130px", fontWeight: 500 }}
                      >
                        <span
                          className={` ${
                            el?.request_status === 1
                              ? "status-incomplete"
                              : "status-complete"
                          } `}
                          style={{
                            borderRadius: "16px",
                            color: el?.request_status === 3 ? "#82b01f" : "",
                            background:
                              el?.request_status === 3 ? "#e7f0d4" : "",
                          }}
                        >
                          {el?.request_status
                            ? el?.request_status === 2
                              ? "Rejected"
                              : el?.request_status === 1
                              ? "Pending"
                              : "Approved"
                            : "NA"}
                        </span>
                      </td>
                    );
                  } else if (header?.value === "action") {
                    return (
                      <td className={`text-left mt-5`}>
                        <div className="d-flex">
                          <img
                            src={ViewIcon}
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              history?.push({
                                pathname: `/my-space/pending-leaves/pending-leaves-details/${el?._id}`,
                                state: { data: el },
                              })
                            }
                            alt="view-icon"
                          />
                        </div>
                      </td>
                    );
                  }
                })}
            </tr>
          );
        })}
    </>
  );
};

export default LeavePendingApprovalTableData;
